import { form } from 'stores';

import { SUPPORT_TASK_MANAGER_FORM } from '../constants';

export const activeActionView = (value: string): boolean => {
  const action = form.fetch<string>(SUPPORT_TASK_MANAGER_FORM, 'action');
  return Boolean(action && action === value);
};
